import { isEmail, isURL } from 'validator'
import { Opaque } from 'types'
import { isDevOrTest } from 'utils/nodeEnv'

export type UrlString = Opaque<string, 'Url'>

export const isUrlString = (x: string): x is UrlString => {
  const isDevUrl = isDevOrTest() && x.includes('localhost')
  return isURL(x, { require_tld: !isDevUrl }) && !isEmail(x)
}
export const urlString = (x: string | null) => (x && isUrlString(x) ? x : null)
